import React from 'react'
import styled from 'styled-components'

const MapCard = styled.div`
  height: 200px;
  background: #FFF;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11),
              0 5px 15px 0 rgba(0,0,0,0.08);
  :hover {
    position: relative;
    bottom: 5px;
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.4),
                0 5px 15px 0 rgba(0,0,0,0.3);
  }
`
const MapText = styled.div`
  font-family: 'Montserrat', sans-serif;
  color: #0063c0;
  padding: 15px;
`
const MapTitle = styled.h5`
  font-size: 16px;
`

const MapSummary = ({map}) => {
  return (
    <MapCard>
      <MapText>
        <MapTitle>{map.title}</MapTitle>
        <p>{map.content}</p>
      </MapText>
    </MapCard>
  )
}

export default MapSummary



// WEBPACK FOOTER //
// ./src/components/maps/MapSummary.js